(function() {
  'use strict';

  const CONFIG = {
    maxLength: 12,
    allowedPattern: /^[a-zA-Z0-9\s!@#$%^&*()_\-.,'"]*$/,
    engravingPrice: 0,
    textOverlayPosition: { bottom: '15%' }
  };

  // Returns the max character limit for the current variant (from metafield, fallback to CONFIG.maxLength)
  function getMaxLength() {
    if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
      const variantData = window.personalizationData[currentVariantId];
      if (variantData.maxCharacters && !isNaN(variantData.maxCharacters)) {
        return parseInt(variantData.maxCharacters, 10);
      }
    }
    return CONFIG.maxLength;
  }

  // Updates the input maxlength attribute and all counter/instruction UI elements
  function applyMaxLength() {
    const max = getMaxLength();
    if (elements.input) {
      elements.input.maxLength = max;
      // Trim existing value if it exceeds new limit
      if (elements.input.value.length > max) {
        elements.input.value = elements.input.value.slice(0, max);
      }
    }
    const charMaxEl = document.getElementById('personalizationCharMax');
    if (charMaxEl) charMaxEl.textContent = max;
    const maxCharsTextEl = document.getElementById('personalizationMaxCharsText');
    if (maxCharsTextEl) maxCharsTextEl.textContent = max;
    updateCharCounter();
  }

  // Updates the live character counter display
  function updateCharCounter() {
    const charCountEl = document.getElementById('personalizationCharCount');
    if (charCountEl && elements.input) {
      const current = elements.input.value.length;
      const max = getMaxLength();
      charCountEl.textContent = current;
      // Visual warning when near/at limit
      const counterWrapper = charCountEl.closest('.personalization-char-counter');
      if (counterWrapper) {
        counterWrapper.classList.toggle('at-limit', current >= max);
        counterWrapper.classList.toggle('near-limit', current >= Math.max(1, max - 3) && current < max);
      }
    }
  }

  let currentVariantId = null;
  let selectedPersonalizationText = '';
  let isPersonalizationEnabled = false;

  const elements = {
    overlay: null,
    modal: null,
    openBtn: null,
    closeBtn: null,
    skipBtn: null,
    confirmBtn: null,
    previewBtn: null,
    input: null,
    textOverlay: null,
    productImage: null,
    errorMessage: null,
    tncToggle: null,
    tncContent: null,
    hiddenTextInput: null,
    previewOverlay: null,
    previewImage: null,
    previewText: null,
    closePreview: null
  };

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupElements);
    } else {
      setupElements();
    }
  }

  function setupElements() {
    elements.overlay = document.getElementById('personalizationModalOverlay');
    elements.modal = document.getElementById('personalizationModal');
    elements.openBtn = document.getElementById('openPersonalizationModal');
    elements.closeBtn = document.getElementById('closePersonalizationModal');
    elements.skipBtn = document.getElementById('skipPersonalization');
    elements.confirmBtn = document.getElementById('confirmPersonalization');
    elements.previewBtn = document.getElementById('previewPersonalization');
    elements.input = document.getElementById('personalizationInput');
    elements.textOverlay = document.getElementById('personalizationTextOverlay');
    elements.productImage = document.getElementById('personalizationProductImage');
    elements.errorMessage = document.getElementById('personalizationError');
    elements.hiddenTextInput = document.getElementById('personalizationText');
    elements.previewOverlay = document.getElementById('personalizationPreviewOverlay');
    elements.previewImage = document.getElementById('previewImage');
    elements.previewText = document.getElementById('previewText');
    elements.closePreview = document.getElementById('closePreview');

    if (!elements.overlay || !elements.openBtn) {
      console.warn('Personalization modal elements not found');
      return;
    }

    attachEventListeners();
    detectCurrentVariant();
  }

  function attachEventListeners() {
    if (elements.openBtn) {
      elements.openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    }

    // Close modal
    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    if (elements.overlay) {
      elements.overlay.addEventListener('click', function(e) {
        if (e.target === elements.overlay) {
          closeModal();
        }
      });
    }

    if (elements.skipBtn) {
      elements.skipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        skipPersonalization();
      });
    }

    if (elements.confirmBtn) {
      elements.confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        confirmPersonalization();
      });
    }

    if (elements.previewBtn) {
      elements.previewBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openPreview();
      });
    }

    if (elements.closePreview) {
      elements.closePreview.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePreview();
      });
    }

    if (elements.previewOverlay) {
      elements.previewOverlay.addEventListener('click', function(e) {
        if (e.target === elements.previewOverlay) {
          closePreview();
        }
      });
    }

    if (elements.input) {
      elements.input.addEventListener('input', handleInput);
      elements.input.addEventListener('input', updateCharCounter);
      elements.input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!elements.confirmBtn.disabled) {
            confirmPersonalization();
          }
        }
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target.name === 'id' || e.target.classList.contains('variant-selector')) {
        detectCurrentVariant();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.overlay && elements.overlay.style.display !== 'none') {
        closeModal();
      }
    });
  }

  function openModal() {
    if (!elements.overlay) return;

    detectCurrentVariant();
    updateModalContent();
    
    elements.overlay.style.display = 'flex';
    
    setTimeout(() => {
      elements.overlay.classList.add('active');
    }, 10);

    if (elements.input) {
      setTimeout(() => {
        elements.input.focus();
      }, 300);
    }

    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!elements.overlay) return;

    elements.overlay.classList.remove('active');
    
    setTimeout(() => {
      elements.overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  function skipPersonalization() {
    isPersonalizationEnabled = false;
    selectedPersonalizationText = '';
    
    if (elements.hiddenTextInput) elements.hiddenTextInput.value = '';
    closeModal();
  }

  function confirmPersonalization() {
    const text = elements.input ? elements.input.value.trim() : '';
    
    if (!text || !validateInput(text)) {
      showError('Please enter a valid personalization text');
      return;
    }

    isPersonalizationEnabled = true;
    selectedPersonalizationText = text;
    
    if (elements.hiddenTextInput) elements.hiddenTextInput.value = text;
    
    generatePreviewImage(text, (previewImageUrl) => {
      closeModal();
      if (previewImageUrl) {
        console.log('✅ Preview image uploaded, adding to cart with URL');
        addToCart(currentVariantId, true, text, previewImageUrl);
      } else {
        console.warn('⚠️ Preview upload failed, adding without preview');
        addToCart(currentVariantId, true, text, null);
      }
    });
  }

  function handleInput(e) {
    const text = e.target.value;
    
    updateTextPreview(text);
    updateCharCounter();
    
    const isValid = validateInput(text);
    
    if (elements.confirmBtn) {
      elements.confirmBtn.disabled = !isValid || text.trim() === '';
    }
    if (elements.previewBtn) {
      elements.previewBtn.disabled = !isValid || text.trim() === '';
    }

    if (isValid) {
      hideError();
    }
  }

  function validateInput(text) {
    const maxLen = getMaxLength();
    if (text.length > maxLen) {
      showError(`Maximum ${maxLen} characters allowed`);
      return false;
    }

    if (!CONFIG.allowedPattern.test(text)) {
      showError('Invalid characters detected. Only letters, numbers, and select special characters allowed.');
      return false;
    }

    const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
    if (emojiPattern.test(text)) {
      showError('Emojis are not allowed');
      return false;
    }

    return true;
  }

  function showError(message) {
    if (elements.errorMessage) {
      elements.errorMessage.textContent = message;
      elements.errorMessage.style.display = 'block';
    }
  }

  function hideError() {
    if (elements.errorMessage) {
      elements.errorMessage.style.display = 'none';
      elements.errorMessage.textContent = '';
    }
  }

  function updateTextPreview(text) {
    if (!elements.textOverlay) return;

    if (text.trim() === '') {
      elements.textOverlay.textContent = '';
      elements.textOverlay.style.display = 'none';
    } else {
      elements.textOverlay.textContent = text;
      elements.textOverlay.style.display = 'block';
      
      if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
        const variantData = window.personalizationData[currentVariantId];
        if (variantData.textStyle) {
          Object.assign(elements.textOverlay.style, variantData.textStyle);
        }
      }
    }
  }

  function detectCurrentVariant() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      currentVariantId = variantInput.value;
      return;
    }

    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      currentVariantId = variantSelect.value;
      return;
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('[name="id"]');
      if (variantIdInput) {
        currentVariantId = variantIdInput.value;
        return;
      }
    }

    const themeVariantSelectors = [
      '.product-form__input input[name="id"]',
      '#product-select',
      '.variant-select',
      '[data-variant-id]'
    ];

    for (const selector of themeVariantSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        currentVariantId = element.value || element.dataset.variantId;
        if (currentVariantId) return;
      }
    }

    console.warn('Could not detect current variant');
  }

  function updateModalContent() {
    if (!currentVariantId || !window.personalizationData) return;

    const variantData = window.personalizationData[currentVariantId];
    if (!variantData) return;

    // Apply per-variant character limit from metafield
    applyMaxLength();

    if (elements.productImage) {
      if (variantData.image) {
        elements.productImage.src = variantData.image;
      } else {
        const featuredImage = document.querySelector('.product-featured-image img, .product__media img, [data-product-featured-image]');
        if (featuredImage) {
          elements.productImage.src = featuredImage.src;
        }
      }
    }

    if (elements.textOverlay && variantData.textStyle) {
      Object.assign(elements.textOverlay.style, variantData.textStyle);
    }
    
    if (elements.input && elements.input.value) {
      updateTextPreview(elements.input.value);
    }
  }


  function openPreview() {
    const text = elements.input ? elements.input.value.trim() : '';
    
    if (!text || !validateInput(text)) {
      showError('Please enter valid text to preview');
      return;
    }

    if (!elements.previewOverlay) return;

    if (elements.previewImage && elements.productImage) {
      elements.previewImage.src = elements.productImage.src;
    }

    if (elements.previewText) {
      elements.previewText.textContent = text;
      
      if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
        const variantData = window.personalizationData[currentVariantId];
        if (variantData.textStyle) {
          Object.assign(elements.previewText.style, variantData.textStyle);
          elements.previewText.style.fontSize = '18px';
        }
      }
    }

    elements.previewOverlay.style.display = 'flex';
    setTimeout(() => {
      elements.previewOverlay.classList.add('active');
    }, 10);
  }

  function closePreview() {
    if (!elements.previewOverlay) return;

    elements.previewOverlay.classList.remove('active');
    setTimeout(() => {
      elements.previewOverlay.style.display = 'none';
    }, 300);
  }

  function generatePreviewImage(text, callback) {
    console.log('🎨 Starting preview image generation for text:', text);
    
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    // Use the current product image
    const imageSrc = elements.productImage ? elements.productImage.src : '';
    console.log('📷 Image source:', imageSrc);
    
    if (!imageSrc) {
      console.error('❌ No image source found');
      callback(null);
      return;
    }
    
    img.onload = function() {
      console.log('✅ Image loaded successfully. Dimensions:', img.width, 'x', img.height);
      
      // Set canvas size to match image
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Draw product image
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      console.log('✅ Product image drawn on canvas');
      
      // Get text style from variant data
      let textStyle = {
        fontSize: '14px',
        color: '#808080',
        fontWeight: '500',
        letterSpacing: '-0.5px',
        bottom: '15%',
        rotation: '0deg'
      };
      
      if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
        const variantData = window.personalizationData[currentVariantId];
        if (variantData.textStyle) {
          textStyle = { ...textStyle, ...variantData.textStyle };
          console.log('✅ Text style loaded from variant data:', textStyle);
        }
      }
      
      // Calculate text position
      const bottomPercent = parseFloat(textStyle.bottom) || 15;
      const textY = canvas.height - (canvas.height * bottomPercent / 100);
      const textX = canvas.width / 2;
      console.log('📍 Text position: X=' + textX + ', Y=' + textY);
      
      // Apply text styling
      const fontSize = parseInt(textStyle.fontSize) || 14;
      const scaledFontSize = Math.floor(fontSize * (canvas.width / 350)); // Scale based on image width
      
      ctx.font = `${textStyle.fontWeight} ${scaledFontSize}px Arial, sans-serif`;
      ctx.fillStyle = textStyle.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      console.log('✅ Text styling applied. Font:', ctx.font, 'Color:', ctx.fillStyle);
      
      // Handle rotation
      const rotation = parseFloat(textStyle.rotation) || 0;
      if (rotation !== 0) {
        console.log('🔄 Applying rotation:', rotation + '°');
        ctx.save();
        ctx.translate(textX, textY);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.fillText(text, 0, 0);
        ctx.restore();
      } else {
        ctx.fillText(text, textX, textY);
      }
      console.log('✅ Text drawn on canvas:', text);
      
      // Convert canvas to blob and upload to ImgBB
      canvas.toBlob(function(blob) {
        console.log('📤 Uploading preview to ImgBB...');
        console.log('Blob size:', Math.round(blob.size / 1024) + 'KB');
        
        const formData = new FormData();
        formData.append('image', blob);
        
        // Upload to ImgBB
        fetch('https://api.imgbb.com/1/upload?key=06e6055dd96e349bc8b46f5ebb65bc00', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const imageUrl = data.data.url;
            console.log('✅ Preview uploaded successfully!');
            console.log('Image URL:', imageUrl);
            console.log('Delete URL:', data.data.delete_url);
            callback(imageUrl);
          } else {
            console.error('❌ ImgBB upload failed:', data);
            callback(null);
          }
        })
        .catch(error => {
          console.error('❌ Error uploading to ImgBB:', error);
          callback(null);
        });
      }, 'image/png', 0.8);
    };
    
    img.onerror = function(error) {
      console.error('❌ Failed to load image for preview generation:', error);
      console.error('Image src was:', imageSrc);
      callback(null);
    };
    
    img.src = imageSrc;
  }

  function addToCart(variantId, withPersonalization, text = '', previewImageUrl = null) {
    console.log('🛒 Adding to cart...');
    console.log('Variant ID:', variantId);
    console.log('Personalization text:', text);
    console.log('Preview image URL:', previewImageUrl || 'NO');
    
    if (!variantId) {
      alert('Please select a variant');
      return;
    }

    const formData = {
      id: variantId,
      quantity: 1
    };

    if (withPersonalization && text) {
      formData.properties = {
        'Personalization': text
      };
      
      if (previewImageUrl) {
        formData.properties['_Preview Image URL'] = previewImageUrl;
        console.log('✅ Preview image URL added to cart properties:', previewImageUrl);
      } else {
        console.warn('⚠️ No preview image URL to add to cart');
      }
    }

    console.log('📤 Sending to cart:', {
      id: formData.id,
      quantity: formData.quantity,
      properties: formData.properties ? Object.keys(formData.properties) : 'none'
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('✅ Added to cart successfully:', data);
      console.log('Cart item properties:', data.properties);
      
      if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cartDrawer) {
        Shopify.theme.cartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      setTimeout(() => {
        updateCartCount();
        // Trigger GoKwik preview injection
        if (window.injectGoKwikPreviews) {
          console.log('🔄 Triggering GoKwik preview injection');
          setTimeout(() => {
            window.injectGoKwikPreviews();
          }, 1000);
        }
      }, 500);
    })
    .catch(error => {
      console.error('❌ Error adding to cart:', error);
      alert('❌ Error adding to cart. Please try again.');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  window.toggleTnC = function() {
    const tncContent = document.getElementById('tncContent');
    const tncToggle = document.querySelector('.tnc-toggle');
    
    if (tncContent && tncToggle) {
      tncContent.classList.toggle('active');
      tncToggle.classList.toggle('active');
      
      if (tncContent.classList.contains('active')) {
        tncContent.style.display = 'block';
      } else {
        setTimeout(() => {
          tncContent.style.display = 'none';
        }, 300);
      }
    }
  };

  window.PersonalizationModal = {
    open: openModal,
    close: closeModal,
    openPreview: openPreview,
    closePreview: closePreview,
    getCurrentVariant: () => currentVariantId,
    getPersonalizationText: () => selectedPersonalizationText,
    isEnabled: () => isPersonalizationEnabled
  };

  init();

})();
